import React from 'react';
import ResultTable from "../ResultTable/ResultTable";
import Hash from "object-hash";
import { getFields } from "../../../../web/Utils/utils";
import { NoResourceMessage, RelativeDiv, SearchInput, TableWrapper } from "./PlaylistComponents/PlaylistComponents"

export const PlaylistAsTable = ( props ) => {
    const { selectedTab, combinedTabs, filteredCombinedTabs, handleSearch, searchTerm, setSearchTerm, isUnifiedTable } = props;

    let fieldsExcludes = ['filename', 'filesize', 'entityBundle', 'vIframe', 'entityChanged', 'entityCreated', "description", "tags"];
    let fieldsExcludeCombined = ['filename', 'filesize', 'entityBundle', 'vIframe', 'entityChanged', 'entityCreated', "description"];
    if (process.env.REACT_APP_SEE_VERSION !== "1") {
      fieldsExcludes.push("version");
      fieldsExcludeCombined.push("version");
    }

    let fieldsToShow = []
    if (selectedTab && selectedTab.files && selectedTab.files[0] && selectedTab.files[0].metadata) {
      fieldsToShow = getFields(selectedTab.files[0].metadata, fieldsExcludes);
    }

    let fieldsToShowCombined = []
    if (combinedTabs[0] && combinedTabs[0].metadata) {
      fieldsToShowCombined = getFields(combinedTabs[0].metadata, fieldsExcludes);
    }

    let fieldsToShowFilteredCombined = []
    if (filteredCombinedTabs[0] && filteredCombinedTabs[0].metadata) {
      fieldsToShowFilteredCombined = getFields(filteredCombinedTabs[0].metadata, fieldsExcludeCombined);
    }

    return (
        <RelativeDiv>
            <SearchInput
                type="text"
                placeholder='Filter by name, description or section (e.g., "Manual").'
                onChange={ ( e ) => {
                    setSearchTerm(e.target.value);
                    handleSearch(e.target.value);
                }}
                value={searchTerm}
            />
            {selectedTab ? (
                <TableWrapper id="tableWrapper">
                    <ResultTable
                        rowWidth={80}
                        key={Hash(JSON.stringify(selectedTab))}
                        centered
                        fieldsToShow={fieldsToShow}
                        title={selectedTab.title}
                        data={searchTerm ? selectedTab.files.filter(file =>
                            file.metadata.filename.toLowerCase().includes(searchTerm.toLowerCase()) ||
                            (file.metadata.description && file.metadata.description.toLowerCase().includes(searchTerm.toLowerCase()))
                        ) : selectedTab.files}
                        type={"playlist"}
                        tableUnified={isUnifiedTable}
                    />
                </TableWrapper>
            ) : (<>
                {  filteredCombinedTabs.length === 0 && combinedTabs  &&  combinedTabs.length > 0 && searchTerm.length ===0  &&  <TableWrapper id="tableWrapper" key={Hash(JSON.stringify(combinedTabs[0]))}>
                    <ResultTable
                        rowWidth={80}
                        key={Hash(JSON.stringify(combinedTabs[0]))}
                        centered
                        fieldsToShow={fieldsToShowCombined}
                        title={""}
                        data={ combinedTabs }
                        type={"playlist"}
                        tableUnified={isUnifiedTable}
                    />
                </TableWrapper>
                }
                {   filteredCombinedTabs.length > 0  &&  <TableWrapper id="tableWrapper" key={Hash(JSON.stringify(combinedTabs[0]))}>
                    <ResultTable
                        rowWidth={80}
                        key={Hash(JSON.stringify(filteredCombinedTabs[0]))}
                        centered
                        fieldsToShow={fieldsToShowFilteredCombined}
                        title={""}
                        data={ filteredCombinedTabs }
                        type={"playlist"}
                        tableUnified={isUnifiedTable}
                    />
                </TableWrapper>
                }
            </> )
            }
            {filteredCombinedTabs && filteredCombinedTabs.length === 0 &&  searchTerm && (
                <NoResourceMessage>
                    No resources found for "{searchTerm}". Try adjusting your search or clearing the filter to see all available resources.
                </NoResourceMessage>
            )}
        </RelativeDiv>
        );
}
